import React from 'react';
import { useEffect } from 'react';

import HeroSection from './components/HeroSection';
import WorkWithUs from './components/WorkWithUs';
import Solution from './components/Solution';
import AboutOurWork from './components/AboutOurWork';

function Home() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);
  return (
    <div>
      <div className="w-full bg-gray-900">
        <HeroSection />
      </div>
      <AboutOurWork />
      <Solution />
      <WorkWithUs />
    </div>
  );
}

export default Home;
